import React from 'react';
import { Heading } from '@components/Landing/shared/Heading';
import { Item, Select } from '@components/basics/forms/inputs/Select';
import { useAuth } from '@context/auth/base';
import { FeaturedStatusEnum, ReleaseStatusEnum } from '@hooks/ReleaseStatus/schema';
import { FeaturedStatusParser, ReleaseStatusParser } from '@hooks/ReleaseStatus/store';
import { useReleaseStatus } from '@hooks/ReleaseStatus/useReleaseStatus';
import { NAV_LINKS } from '@utils/constants';
import { formatPascalCase } from '@utils/helpers';

export const RecentDropsPageHeader = ({ loading }: { loading: boolean }) => {
  const { isAuthenticatedWithAPI, isConnectingAPIUser } = useAuth();
  const { recent, updateRecent } = useReleaseStatus();

  return (
    <div className="flex flex-col gap-y-2 md:gap-y-4">
      <Heading header="Recent Drops" pathnameUri={NAV_LINKS.Recent} />
      <div className="flex w-full">
        <div className="flex items-center gap-2">
          <div className="w-[120px]">
            <Select
              onValueChange={value => {
                updateRecent({
                  featuredStatus: FeaturedStatusParser(value),
                });
              }}
              value={recent.featuredStatus}
              disabled={loading}
            >
              {Object.values(FeaturedStatusEnum.enum).map(value => {
                const disabled =
                  (value === FeaturedStatusEnum.enum.Following && !isAuthenticatedWithAPI) ||
                  isConnectingAPIUser;

                return (
                  <Item key={value} value={value} disabled={disabled}>
                    {formatPascalCase(value)}
                  </Item>
                );
              })}
            </Select>
          </div>

          <div className="w-[160px]">
            <Select
              onValueChange={value => {
                updateRecent({
                  releaseStatus: ReleaseStatusParser(value),
                });
              }}
              value={recent.releaseStatus}
            >
              {Object.values(ReleaseStatusEnum.enum).map(value => {
                return (
                  <Item key={value} value={value}>
                    {formatPascalCase(value)}
                  </Item>
                );
              })}
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
};
